import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { TransactionService } from '../services/transaction.service';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.css']
})
export class SideNavbarComponent implements OnInit {

  desktop=true
  active = 'app'
  constructor(public authService : AuthService, public transactionService : TransactionService, private common : CommonService, private router : Router) { }

  ngOnInit(): void {
    if(window.innerWidth<768){
      this.desktop = false
    }
  }

  showOnMenu(tab){
    if(this.active == 'app' && (tab=='connect' || tab=='transactions' || tab=='buy')){
      return true
    }
    else if(this.active == 'transactions' && (tab=='app' || tab=='buy')){
      return true
    }
    else if(this.active == 'buy' && (tab=='connect' || tab=='transactions' || tab=='app')){
      return true
    }
    else{
      return false
    }
  }

  async connectWallet(){
    let address
    // console.log(this.transactionService.selectedSource)
    if(this.transactionService.selectedSource){
      if(this.transactionService.selectedSource.wallet=='walletConnect'){
        address = await this.transactionService.connectWalletCusd()
      }
      else if(this.transactionService.selectedSource.wallet=='terraStation'){
        address = await this.transactionService.connectWalletTerra()
      }
      else if(this.transactionService.selectedSource.wallet=='bnbClient'){
        address = await this.transactionService.connectWalletBinance()
      }
      else if(this.transactionService.selectedSource.wallet=='near'){
        address = await this.transactionService.connectWalletNear()
      }
      if(address){
        this.transactionService.isConnectedWallet = true
        this.transactionService.connectedWalletAddress = address
        this.transactionService.connectedWalletAddressModified = address.slice(0,20)
        this.checkBalance()
        document.getElementById('navbarNav').classList.remove('show')
      }
    }
    else{
      alert("Please select stable coin")
    }
  }

  async checkBalance(){
    if(this.transactionService.selectedSource.wallet=='walletConnect'){
      this.common.showLoader()
      this.transactionService.balance = await this.transactionService.getBalance(this.transactionService.connectedWalletAddress, this.transactionService.source)
      this.common.hideLoader()
    }
    else if(this.transactionService.selectedSource.wallet=='bnbClient'){
      this.common.showLoader()
      let walletBalance = await this.transactionService.getBalanceBinance()
      
      this.transactionService.balance = +walletBalance
      this.common.hideLoader()
    }
    else if(this.transactionService.selectedSource.wallet=='near'){
      this.common.showLoader()
      let nearBal = await this.transactionService.getNearBalance()
      this.transactionService.balance = +nearBal
      this.common.hideLoader()
    }
    this.transactionService.balance = Math.round(+this.transactionService.balance*100) / 100
  }

  changeActive(data){
    this.active = data
    if(data == 'transactions')  this.router.navigateByUrl('/transaction-history')
    else if(data == 'app')  this.router.navigateByUrl('/dashboard')
    else if(data == 'buy')  this.router.navigateByUrl('/buy-coins')
    // data == 'transactions' ? this.router.navigateByUrl('/transaction-history') : this.router.navigateByUrl('/dashboard')
    document.getElementById('navbarNav').classList.remove('show')
  }
}
